import { Div, Button } from '@codesuma/baseline'
import { IDayCell } from '../../../services/calendar'
import dayColors from '../../../services/day-colors'
import { DAY_COLORS } from '../../../configs/day-colors'
import { paintDayColor } from '../../../helpers/day-color'
import style from './index.module.css'

// The day's own colour: its name, the palette under it, and the line that
// takes the colour off again. A pick is kept at once, and the calendar shows
// it under the day straight away — over the calendar, in the row just above
// the sheet. The tab's stop on the bar has no words, so this page says what it
// is.
export const DayColor = (day: IDayCell) => {
    const base = Div()
    base.addClass(style.dayColor)

    const title = Div('رنگ روز')
    title.addClass(style.dayColorTitle)
    base.append(title)

    const palette = Div()
    palette.addClass(style.palette)
    base.append(palette)

    const swatches = DAY_COLORS.map(c => {
        const swatch = Button()
        swatch.addClass(style.swatch)
        swatch.attr('aria-label', c.name)
        paintDayColor(swatch.el, c)
        swatch.on('click', () => {
            dayColors.set(day, c.id)
            sync()
        })
        palette.append(swatch)
        return { id: c.id, swatch }
    })

    // A small line under the palette, there only while the day has a colour to
    // take off — hidden rather than gone, so nothing moves when it comes.
    const clear = Button('بدون رنگ')
    clear.addClass(style.clearColor)
    clear.on('click', () => {
        dayColors.set(day, null)
        sync()
    })
    base.append(clear)

    const sync = () => {
        const current = dayColors.forDay(day)
        for (const { id, swatch } of swatches) {
            swatch.toggleClass(style.swatchPicked, id === current)
            swatch.attr('aria-pressed', String(id === current))
        }
        clear.style({ visibility: current ? '' : 'hidden' })
    }
    sync()

    return base
}
